// ABOUTME: Version update checker using toast notifications
// ABOUTME: Shows persistent toast when a new version is available

import { RefreshCwIcon } from "lucide-react";
import { useEffect } from "react";
import { toast } from "sonner";

const CHECK_INTERVAL = 30_000; // 30 секунд
const UPDATE_TOAST_ID = "app-update";

export function UpdateBanner() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-cache" });
        const { version } = await res.json();

        if (version !== __APP_VERSION__) {
          toast.info(
            "Доступна новая версия платформы. Обновите страницу для получения последних обновлений.",
            {
              id: UPDATE_TOAST_ID,
              duration: Infinity,
              action: {
                label: <RefreshCwIcon className="size-3.5" />,
                onClick: () => window.location.reload(),
              },
            },
          );
        }
      } catch {
        // Сеть недоступна — игнорируем
      }
    };

    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return null;
}
